'use client';
import { memo, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as bondsAction from '../../redux/actions/bonds';
import Pagination from '../common/Pagination';
import TableLazyLoading from '../screenerComponents/TableLazyLoading';
import useWindowSize from '@/hooks/useWindowSize';
import Link from 'next/link';
import { setEncodetext } from '@/services/helperFunctions';

const IssuerBondsPage = ({
    getBonds,
    clientIp,
    getfollowBond,
    issuerName,
    convertedIssuer,
    IssuerDatas,
    getIssuerHistory,
    IssuerRelatedBonds,
}: any) => {
    // const [show404, setShow404] = useState(false);
    // const [issuerHistory, setIssuerHistory] = useState({})

    // useEffect(() => {
    //     let body = {
    //         issuer_name: convertedIssuer,
    //     }
    //     // getIssuerHistory(body).then((res: any) => {
    //     //     setIssuerHistory(res?.data);
    //     // })
    // }, [convertedIssuer])
    const [showChange_percent, setShowChange_percent] = useState(false);
    const [yieldColumn, setYieldColumn] = useState('market_yield');
    const [SortedNameData, setSortedNameData] = useState('bond_name');

    const currentYear = new Date().getFullYear();
    const [filters, setFilters] = useState({
        page_no: 1,
        per_page: 25,
        user_id: '',
        issuer: convertedIssuer,
        issuer_search_type: 'E',
        yield_from: 0,
        yield_to: 30,
        maturity_from_year: currentYear,
        maturity_to_year: currentYear + 100,
        country: '',
        currency: '',
        region: '',
        industry: '',
        coupon_from: 0,
        coupon_to: 30,
        callable: '',
        issue_type: '',
        status: '',
        fulltext: '',
        sorting_column_sorting_order: 'bond_name asc',
    });

    interface BondsData {
        bonds?: any[];
        page_no?: number;
        per_page?: number;
        start_record?: number;
        end_record?: number;
        total_records?: number;
        filteredRecords?: number;
    }

    const [bondsData, setBondsData] = useState<BondsData>(IssuerRelatedBonds);

    const [bondsListLoading, setBondsListLoading] = useState(false);
    let isCancelled = false;
    const handleGetBondsListData = (req: any) => {
        setBondsListLoading(true);
        if (clientIp?.IPv4) {
            const body = {
                params: {
                    ...filters,
                    ...req,
                    ip_address: clientIp.IPv4,
                },
            };
            isCancelled = true;
            getBonds(body).then((res: any) => {
                setBondsData(res);
                setBondsListLoading(false);
                isCancelled = true;
            });
        } else {
            const body = {
                params: {
                    ...filters,
                    ...req,
                },
            };
            isCancelled = true;
            console.log('Fetching issuer bonds with body', body);

            getBonds(body).then((res: any) => {
                setBondsData(res);
                setBondsListLoading(false);
                isCancelled = true;
            });
        }
    };
    // useEffect(() => {
    //     handleGetBondsListData({})
    // }, [convertedIssuer])
    const handleChangePercent = () => {
        setShowChange_percent(!showChange_percent);
    };
    const handleYieldClick = (val: string) => {
        setTimeout(() => handleTableSort(val), 100);
    };
    const handleTableSort = (name: string) => {
        try {
            if (typeof document !== 'undefined') {
                setSortedNameData(name);
                const table = document.getElementById(name);
                const sortValue = table ? table?.getAttribute('aria-sort') : document.getElementById(name)?.getAttribute('aria-sort');
                var els = document.querySelectorAll('[aria-sort]');
                for (var i = 0; i < els.length; i++) {
                    els[i].setAttribute('aria-sort', '');
                }
                const sortType = sortValue === 'desc' ? 'asc' : 'desc';
                table?.setAttribute('aria-sort', sortType);
                handleGetBondsListData({ sorting_column_sorting_order: `${name} ${sortType === 'desc' ? 'asc' : 'desc'}` });
            }
        } catch (e) {
            console.log(e);
        }
    };

    // const [showPosition, setShowPosition] = useState(false);
    // const [bondId, setBondId] = useState();
    // const [selectedAction, setSelectedAction] = useState('buyPrice');

    // const handleShowPosition = (bond_id: any, action: any) => {
    //     setShowPosition(true);
    //     setBondId(bond_id);
    //     setSelectedAction(action);
    // };
    const handleSetPerpage = (per_page: number) => {
        setFilters({ ...filters, per_page: per_page });
        handleGetBondsListData({ per_page: per_page });
    };
    const handleSetPageNumber = (page_no: number) => {
        setFilters({ ...filters, page_no: page_no });
        handleGetBondsListData({ page_no: page_no });
    };
    const windowSize = useWindowSize();
    const isMobile = useMemo(() => windowSize?.width <= 600, [windowSize?.width]);
    // const tableHeight = useMemo(() => (windowSize?.height - 270 - (isMobile ? 350 : 100)) + 'px', [windowSize?.height, isMobile]);
    const issuerBondsData = bondsData || IssuerRelatedBonds;
    return (
        <>
            <div className="container-fluid px-lg-3 mt-lg-2 mt-4 pt-3">
                <nav aria-label="breadcrumb px-3">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                            <Link href="/screener" className="no-underline text-sm" passHref>
                                <span>Screener</span>
                            </Link>
                        </li>
                        <li className="breadcrumb-item">
                            <Link href="/issuers" className="no-underline text-sm" passHref>
                                <span>Issuers index</span>
                            </Link>
                        </li>
                        <li className="breadcrumb-item">
                            <Link
                                href={`/issuers/${typeof convertedIssuer === 'string' ? convertedIssuer.slice(0, 1) : ''}`}
                                className="no-underline text-sm"
                            >
                                <span>{typeof convertedIssuer === 'string' ? convertedIssuer.slice(0, 1) : ''}</span>
                            </Link>
                        </li>
                        <li className="breadcrumb-item">
                            <Link
                                href={`/issuer-bonds/${typeof issuerName === 'string' ? setEncodetext(convertedIssuer) : ''}`}
                                className="no-underline text-sm"
                            >
                                <span>{typeof convertedIssuer === 'string' ? convertedIssuer : ''}</span>
                            </Link>
                        </li>
                        {/* Add other breadcrumb items here */}
                    </ol>
                </nav>
                {/* <Breadcrumb>
                    <Breadcrumb.Item><Link href="/screener">Screener</Link></Breadcrumb.Item>
                    <Breadcrumb.Item><Link href="/issuers/a">Issuers</Link></Breadcrumb.Item>
                    <Breadcrumb.Item>
                        <Link href={`/issuers/${typeof convertedIssuer === 'string' ? convertedIssuer.slice(0, 1) : ''}`}>
                            {typeof convertedIssuer === 'string' ? convertedIssuer.slice(0, 1) : ''}
                        </Link>
                    </Breadcrumb.Item>
                </Breadcrumb> */}
                <div className="col-lg-8 px-3">
                    <h1 style={{ fontSize: '1.5rem' }} className="text-capitalize">
                        {convertedIssuer} Bonds
                    </h1>
                    <p className="text-muted pe-lg-4" style={{ textAlign: 'justify', fontSize: '13px', maxWidth: '70%' }}>
                        {IssuerDatas?.issuer_overview}
                    </p>
                </div>

                <div className="row gx-5 px-3">
                    <div className="col-lg-8 ">
                        <div style={{ height: '280px', overflow: 'auto' }}>
                            <table className={`table table-responsive`} id="issuer-bonds-table">
                                <thead className="table-secondary sticky-top">
                                    <tr>
                                        <th className=" text-nowrap cursor-pointer" onClick={() => handleTableSort('bond_name')}>
                                            <span className="screener-table-header-select">Bond Name</span>
                                            <span
                                                className={`toggle-columns ${
                                                    SortedNameData === 'bond_name' ? 'table-sort-by' : 'table-sort-by-hidden'
                                                } `}
                                                id="bond_name"
                                            ></span>
                                        </th>
                                        <th className=" text-nowrap  cursor-pointer" onClick={() => handleTableSort('country_name')}>
                                            <span className="screener-table-header-select">Country</span>
                                            <span
                                                className={`toggle-columns ${
                                                    SortedNameData === 'country_name' ? 'table-sort-by' : 'table-sort-by-hidden'
                                                } `}
                                                id="country_name"
                                            ></span>
                                        </th>
                                        <th className="  text-nowrap  cursor-pointer " onClick={() => handleTableSort('maturity')}>
                                            <span className="screener-table-header-select">Maturity</span>
                                            <span
                                                className={`toggle-columns ${
                                                    SortedNameData === 'maturity' ? 'table-sort-by' : 'table-sort-by-hidden'
                                                } `}
                                                id="maturity"
                                            ></span>
                                        </th>
                                        <th className=" text-end  text-nowrap  cursor-pointer " onClick={() => handleTableSort('coupon')}>
                                            <span className="screener-table-header-select">Coupon(%)</span>
                                            {/* <span className={`toggle-columns ${SortedNameData === "coupon" ? 'table-sort-by' : "table-sort-by-hidden"} `} aria-sort="" id='coupon'></span> */}
                                        </th>

                                        <th className="text-end text-nowrap">
                                            <label htmlFor="market_yield">
                                                <select
                                                    onChange={(e) => {
                                                        setYieldColumn(e.target.value);
                                                        handleYieldClick(e.target.value);
                                                    }}
                                                    style={{ fontSize: '12px', fontWeight: '700', borderRadius: '.25rem' }}
                                                    className="screener-table-header-select"
                                                >
                                                    <option value="market_yield" defaultChecked>
                                                        Yield(%)
                                                    </option>
                                                    <option value="ytm">YTM(%)</option>
                                                    <option value="ytw">YTW(%)</option>
                                                </select>
                                                <span
                                                    onClick={() => handleTableSort(yieldColumn)}
                                                    className={`toggle-columns cursor-pointer ${
                                                        SortedNameData === 'market_yield' ||
                                                        SortedNameData === 'ytm' ||
                                                        SortedNameData === 'ytw'
                                                            ? 'table-sort-by'
                                                            : 'table-sort-by-hidden'
                                                    } `}
                                                    id={yieldColumn}
                                                ></span>
                                            </label>
                                        </th>
                                        {/* <th className="text-end text-nowrap" >
                                            <label htmlFor="change_percent" >

                                                <select onChange={handleChangePercent} aria-label="Default select example" style={{ fontSize: "12px", fontWeight: "700", borderRadius: '.25rem' }} className="screener-table-header-select">
                                                    <option value="change">Change</option>
                                                    <option value="changePercent" >Change %</option>
                                                </select>
                                                <span onClick={() => handleTableSort(showChange_percent ? 'changepercentage' : "chng")} className={`toggle-columns cursor-pointer ${SortedNameData === "changepercentage" || SortedNameData === "chng" ? 'table-sort-by' : "table-sort-by-hidden"} `} aria-sort="asc" id={showChange_percent ? 'changepercentage' : "chng"} ></span>

                                            </label>
                                        </th> */}

                                        {/* {isLoggedIn &&
                                            <th width="6%" className="">
                                                <span className="trans-position-head" style={{ color: "transparent" }}></span>
                                            </th>
                                        } */}
                                    </tr>
                                </thead>
                                <tbody>
                                    {bondsListLoading && !bondsData?.bonds && <TableLazyLoading isLoggedIn={true} />}
                                    {issuerBondsData?.bonds?.map((bond: any, index: any) => (
                                        <tr key={bond.isin}>
                                            <td>
                                                <span
                                                    className={`${
                                                        bond.status === 'Active' ? 'link-primary text-dark ' : 'text-muted'
                                                    }  cursor-pointer d-flex flex-column text-black`}
                                                >
                                                    <Link
                                                        href={`/bonds/${bond.isin}`}
                                                        className="text-dark text-sm no-underline text-truncate fw-medium"
                                                    >
                                                        {bond?.bond_name}
                                                    </Link>
                                                    <span className="d-flex align-items-center gap-1">
                                                        <Link
                                                            href={`/bonds/${bond.isin}`}
                                                            className="text-muted text-xs  no-underline text-truncate fw-medium"
                                                        >
                                                            {bond?.issuer}
                                                        </Link>
                                                        {/* {isLoggedIn &&
                                                                    (bond?.follow_bond === true ?
                                                                        <BookmarkCheckFill color="#294772" className="cursor-pointer" title="Unfollow" onClick={() => handleFollowBond(bond.isin, index)} /> : <Bookmark color="#294772" className="cursor-pointer" title="Follow" onClick={() => handleFollowBond(bond.isin, index)} />)
                                                                } */}
                                                    </span>
                                                </span>
                                            </td>

                                            <td className="text-sm">{bond?.country_name === null ? '—' : bond?.country_name}</td>
                                            <td className="text-nowrap text-sm">{bond?.maturity === null ? '—' : bond?.maturity}</td>
                                            <td className="text-end px-4 text-sm" width="10%">
                                                {bond?.coupon === null
                                                    ? bond.description?.slice(0, 2) === 'ZC'
                                                        ? '0.00'
                                                        : '—'
                                                    : bond?.coupon?.toFixed(3)}
                                            </td>
                                            <td className="text-end px-4 text-sm">
                                                {yieldColumn === 'market_yield'
                                                    ? bond?.market_yield === null
                                                        ? bond.description?.slice(0, 2) === 'ZC'
                                                            ? '0.00'
                                                            : '—'
                                                        : bond?.market_yield?.toFixed(2)
                                                    : ''}
                                                {yieldColumn === 'ytm' ? (bond?.ytm === null ? '—' : bond?.ytm?.toFixed(3)) : ''}
                                                {yieldColumn === 'ytw' ? (bond?.ytw === null ? '—' : bond?.ytw?.toFixed(3)) : ''}
                                            </td>
                                            {/* <td className={`text-end px-4 `} >
                                                {showChange_percent ?
                                                    <span className={`${bond.changepercentage === null || bond.changepercentage === 0 ? 'text-dark' : bond.changepercentage > 0 ? 'text-success' : 'text-danger'}`}>
                                                        {bond?.changepercentage === null ? "—" : bond.changepercentage?.toFixed(3)}
                                                    </span>
                                                    :
                                                    <span className={`${bond.chng === null || bond.chng === 0 ? 'text-dark' : bond.chng > 0 ? 'text-success' : 'text-danger'}`}>
                                                        {bond?.chng === null || bond?.chng === 0 ? "—" : bond?.chng > 0 ? "+" + bond?.chng?.toFixed(3) : bond?.chng?.toFixed(3)}
                                                    </span>
                                                }
                                            </td> */}
                                            {/* {isLoggedIn ?
                                                <td className="text-center">
                                                    <DropdownButton id="dropdown-basic-button" className='btn-sm' style={{ width: "10px" }} title={<FontAwesomeIcon icon={faEllipsisVertical} />}>
                                                        <Dropdown.Item onClick={() => handleShowPosition(bond.isin, 'buyPrice')}>Buy</Dropdown.Item>
                                                        <Dropdown.Item onClick={() => handleShowPosition(bond.isin, 'sellPrice')}>Sell</Dropdown.Item>
                                                    </DropdownButton>
                                                </td> : ""} */}
                                        </tr>
                                    ))}
                                    {bondsData?.bonds?.length === 0 && bondsData?.bonds?.length === 0 ? (
                                        <tr>
                                            <td colSpan={7} className="text-center">
                                                No data found!
                                            </td>
                                        </tr>
                                    ) : (
                                        ''
                                    )}
                                </tbody>
                            </table>
                        </div>
                        <Pagination
                            isLoading={bondsListLoading}
                            data={bondsData}
                            setPerpage={handleSetPerpage}
                            setPageNumber={handleSetPageNumber}
                        />
                        <p className="text-sm">
                            <i>
                                Company overview and issue history are AI generated, and should not be cited or relied on without
                                verification.
                            </i>
                        </p>
                    </div>
                    {/* <div className='col-1'></div> */}
                    <div className="col-lg-4 mb-5 mb-lg-1">
                        <h2
                            style={{ fontSize: '14px', color: '#315385', fontWeight: '500' }}
                            className="text-capitalize border-bottom pb-1"
                        >
                            {convertedIssuer} issue history
                        </h2>
                        <p style={{ fontSize: '13px', textAlign: 'justify' }} className="text-muted">
                            {IssuerDatas?.issue_history}
                        </p>
                    </div>
                </div>

                {/* <BondPosition show={showPosition} selectedAction={selectedAction} setShowPosition={setShowPosition} bondId={bondId} onclose={handleClosePosition} /> */}
            </div>

            {/* } */}
        </>
    );
};

const mapStatesToProps = ({
    bonds: {
        isIssuerFirstletterListLoader = false,
        isIssuerFirstletterListData = [],
        bondsData = {},
        clientIp = {},
        noFilterBonds = {},
        isBoandsLoader = false,
        isSearchCreateLoader = false,
        isSearchListLoader = false,
        isSearchDetailListLoader = false,
        searchFilterDetailData = [],
        followBond = {},
        isFollowBondLoader = false,
        isIssuerHistoryLoader = false,
        isIssuerHistoryData = {},
        isbondSearchFilterListLoader = false,
        bondSearchFilterList = [],
    },
}: any) => {
    return {
        isIssuerFirstletterListData,
        isIssuerFirstletterListLoader,
        bondSearchFilterList,
        bondsData,
        clientIp,
        noFilterBonds,
        isBoandsLoader,
        isSearchCreateLoader,
        isSearchListLoader,
        searchFilterDetailData,
        followBond,
        isSearchDetailListLoader,
        isFollowBondLoader,
    };
};

const mapDispatchToProps = (dispatch: any) => {
    return bindActionCreators(
        {
            ...bondsAction,
        },
        dispatch
    );
};

export default memo(connect(mapStatesToProps, mapDispatchToProps)(IssuerBondsPage));
